import React from 'react';
import Page from './Page';
import ShortForm from './ShortForm';
import Select from './Select';
import { TextField, Button } from 'material-ui';
import _ from 'lodash';
import Link from 'react-router-dom/Link';


const YEAR_OPTIONS = _.range((new Date()).getFullYear() - 15,1910);
YEAR_OPTIONS.unshift('');

const MONTH_OPTIONS = [
	{value: '', label:''},
	{value: 1, label:'January'},
	{value: 2, label:'February'},
	{value: 3, label:'March'},
	{value: 4, label:'April'},
	{value: 5, label:'May'},
	{value: 6, label:'June'},
	{value: 7, label:'July'},
	{value: 8, label:'August'},
	{value: 9, label:'September'},
	{value: 10, label:'October'},
	{value: 11, label:'November'},
	{value: 12, label:'December'},
];

const DAY_OPTIONS = _.range(1,32);
DAY_OPTIONS.unshift('');

const GENDER_OPTIONS = [{value:'', label:''}, {value:'male', label:'Male'}, {value:'female', label:'Female'}, {value:'other', label:'Other'}];

const STATE_OPTIONS = _.sortBy([
	{ value: "", label: "" },
	{ value: "AK", label: "Alaska" },
	{ value: "AL", label: "Alabama" },
	{ value: "AR", label: "Arkansas" },
	{ value: "AS", label: "American Samoa" },
	{ value: "AZ", label: "Arizona" },
	{ value: "CA", label: "California" },
	{ value: "CO", label: "Colorado" },
	{ value: "CT", label: "Connecticut" },
	{ value: "DC", label: "District of Columbia" },
	{ value: "DE", label: "Delaware" },
	{ value: "FL", label: "Florida" },
	{ value: "GA", label: "Georgia" },
	{ value: "GU", label: "Guam" },
	{ value: "HI", label: "Hawaii" },
	{ value: "IA", label: "Iowa" },
	{ value: "ID", label: "Idaho" },
	{ value: "IL", label: "Illinois" },
	{ value: "IN", label: "Indiana" },
	{ value: "KS", label: "Kansas" },
	{ value: "KY", label: "Kentucky" },
	{ value: "LA", label: "Louisiana" },
	{ value: "MA", label: "Massachusetts" },
	{ value: "MD", label: "Maryland" },
	{ value: "ME", label: "Maine" },
	{ value: "MI", label: "Michigan" },
	{ value: "MN", label: "Minnesota" },
	{ value: "MO", label: "Missouri" },
	{ value: "MS", label: "Mississippi" },
	{ value: "MT", label: "Montana" },
	{ value: "NC", label: "North Carolina" },
	{ value: "ND", label: "North Dakota" },
	{ value: "NE", label: "Nebraska" },
	{ value: "NH", label: "New Hampshire" },
	{ value: "NJ", label: "New Jersey" },
	{ value: "NM", label: "New Mexico" },
	{ value: "NV", label: "Nevada" },
	{ value: "NY", label: "New York" },
	{ value: "OH", label: "Ohio" },
	{ value: "OK", label: "Oklahoma" },
	{ value: "OR", label: "Oregon" },
	{ value: "PA", label: "Pennsylvania" },
	{ value: "PR", label: "Puerto Rico" },
	{ value: "RI", label: "Rhode Island" },
	{ value: "SC", label: "South Carolina" },
	{ value: "SD", label: "South Dakota" },
	{ value: "TN", label: "Tennessee" },
	{ value: "TX", label: "Texas" },
	{ value: "UT", label: "Utah" },
	{ value: "VA", label: "Virginia" },
	{ value: "VI", label: "Virgin Islands" },
	{ value: "VT", label: "Vermont" },
	{ value: "WA", label: "Washington" },
	{ value: "WI", label: "Wisconsin" },
	{ value: "WV", label: "West Virginia" },
	{ value: "WY", label: "Wyoming" }
	], 'label');



const MARRIAGE_OPTIONS = [
	{ value: "", label: "" },
	{ value: "married", label: "Married" },
	{ value: "widowed", label: "Widowed" },
	{ value: "divorced", label: "Divorced" },
	{ value: "separated", label: "Separated" },
	{ value: "never married", label: "Never Married" },
	{ value: "other", label: "Other" },
];

const EDUCATION_OPTIONS = [
	{ value: "", label: "" },
	{ value: "0", label: "Less than high school degree" },
	{ value: "1", label: "High school" },
	{ value: "2", label: "Some college" },
	{ value: "3", label: "Associate degree" },
	{ value: "4", label: "Bachelor degree" },
	{ value: "5", label: "Graduate degree" },
];

const RACE_OPTIONS = [
	{ value: "", label: "" },
	{ value: "american indian or alaskan native", label: "American Indian or Alaskan Native" },
	{ value: "asian or pacific islander", label: "Asian / Pacific Islander" },
	{ value: "black or african american", label: "Black or African American" },
	{ value: "hispanic american", label: "Hispanic American" },
	{ value: "white caucasian", label: "White / Caucasian" },
	{ value: "other", label: "Other" },
];

const COLOR_BLIND_OPTIONS = [
	{ value: "", label: "" },
	{ value: "not color blind", label: "Not color blind" },
	{ value: "red-green color blindness", label: "Red-green color blindness" },
	{ value: "blue-yellow color blindness", label: "Blue-yellow color blindness" },
	{ value: "complete blindness", label: "Complete color blindness" },
	{ value: "other", label: "Other" },
];

export {
	RACE_OPTIONS,
	EDUCATION_OPTIONS,
	MARRIAGE_OPTIONS,
	STATE_OPTIONS,
	GENDER_OPTIONS,
	DAY_OPTIONS,
	MONTH_OPTIONS,
	YEAR_OPTIONS,
	COLOR_BLIND_OPTIONS,
};

const DeleteAccount = (props) => (
	<div>
		<Button onClick={ () => {window.app.deleteAccount()} } variant="raised" color="secondary">PERMANENTLY DELETE MY ACCOUNT</Button>
		<Button style={{marginLeft:'20px'}} onClick={ () => {window.app.closeDialog();} } variant="raised">Cancel</Button>
		<div style={{fontSize:'12px', marginTop:'15px'}}>
			*If you have a remaining balance on your account, your credit card will be billed.
		</div>
	</div>
)

export default class MyProfile extends Page {

	static get mustBeParticipant(){ return true; }

	constructor(...args){
		super(...args);
		this.app.profileForm.loading = true;
	}

	componentDidMount(){
		this.app.profileForm.load();
	}

	deleteAccount(){
		this.app.openDialog({label: 'Are you sure?', Component:DeleteAccount})
	}

	render(){
		let history = this.app.profileForm.history.experiments || [];

		return (
			<ShortForm 
				label="My Profile"
				formWidth="small"
				submitButton={{label:"Save", onClick:() => { this.app.profileForm.submit()}}}
				waiting={this.app.profileForm.loading}
				errorMessage={this.app.profileForm.errorMessage}
			>
				<div style={{position:'relative'}}>
					<a onClick={this.deleteAccount.bind(this)} className='delete-account' style={{position:'absolute', right:0, top:'-60px', fontSize:'11px'}}>Delete Account</a>
				</div>

				<TextField
					label="Email"
					id="username"
					disabled={true}
					value={this.app.profileForm.username || ''}
					onChange={ e => { this.app.profileForm.username = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					fullWidth/>
				
				{/*
				<TextField
					label="Email"
					id="email"
					value={this.app.profileForm.email || ''}
					onChange={ e => { this.app.profileForm.email = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					fullWidth/>
				*/}

				
				<TextField
					label={<span>Password &nbsp;&nbsp;<Link to="/change-password">edit</Link></span>}
					id="password-fake"
					disabled={true}
					type="password"
					defaultValue={'11111111'}
					margin="normal"
					fullWidth/>
				
				<div style={{marginTop:'30px'}}>
					<b>Experiment <span>Earnings: ${(+this.app.profileForm.history.earnings) || 0}</span></b><br />
					{history.length === 0 ?
						<div>You have not completed any experiments yet.</div>
						:
						<div style={{fontSize:'13px', maxHeight:'180px', overflow:'auto'}}>
						{history.map( (experiment, i) => (
								<div key={experiment.name + '_' + i} >{experiment.completionDateFormatted}: <i>{experiment.experimentName}</i> was completed for ${experiment.incentive}.</div>
						))}
						</div>
					}
				</div>


				<div style={{margin:'50px 0'}}>
					<b>Optional Profile Details</b>
					<div className="p" style={{margin:'15px 0'}}>
						Completing the rest of your profile information is optional. By filling out more of your profile, you may be eligible to participate in more experiments.
					</div>
					<div className="hint" style={{color:'rgb(152, 152, 152)'}}>Note: The data below will be included in your responses when you participate in an experiment.</div>
				</div>

				<Select
					label="Date of Birth"
					id="birth-month"
					value={this.app.profileForm.birthMonth}
					onChange={ o =>{ this.app.profileForm.birthMonth = o.value; this.app.forceUpdate(); } }
					options={MONTH_OPTIONS}
					/>
				<Spacer />
				<Select
					label="Day"
					id="birth-day"
					value={this.app.profileForm.birthDay}
					onChange={ val =>{ this.app.profileForm.birthDay = val; this.app.forceUpdate(); } }
					options={DAY_OPTIONS}
					/>
				<Spacer />
				<Select
					label="Year"
					id="birth-year"
					value={this.app.profileForm.birthYear}
					onChange={ val =>{ this.app.profileForm.birthYear = val; this.app.forceUpdate(); } }
					options={YEAR_OPTIONS}
					/>

				<Select
					label="Gender"
					id="gender"
					width='100px'
					value={this.app.profileForm.gender}
					onChange={ o =>{ this.app.profileForm.gender = o.value; this.app.forceUpdate(); } }
					options={GENDER_OPTIONS}
					newRow
					/>

				<Select
					label="Which race/ethnicity best describes you?"
					id="race"
					width='300px'
					value={this.app.profileForm.race}
					onChange={ o =>{ this.app.profileForm.race = o.value; this.app.forceUpdate(); } }
					options={RACE_OPTIONS}
					newRow
					/>

				<Select
					label="Highest Level of Education"
					id="education"
					width='250px'
					value={this.app.profileForm.educationLevel}
					onChange={ o =>{ this.app.profileForm.educationLevel = o.value; this.app.forceUpdate(); } }
					options={EDUCATION_OPTIONS}
					newRow
					/>

				<TextField
					label="Household Income"
					id="income"
					value={this.app.profileForm.householdIncome || ''}
					onChange={ e => {this.app.profileForm.householdIncome = e.currentTarget.value; this.app.forceUpdate()} }
					margin="normal"
					InputLabelProps={{ shrink: true }}
					/>

				<Select
					label="Marriage Status"
					id="marrige-status"
					width='150px'
					value={this.app.profileForm.marriageStatus}
					onChange={ o =>{ this.app.profileForm.marriageStatus = o.value; this.app.forceUpdate(); } }
					options={MARRIAGE_OPTIONS}
					newRow
					/>


				<TextField
					label="Address City"
					id="city"
					value={this.app.profileForm.city || ''}
					onChange={ e => {this.app.profileForm.city = e.currentTarget.value; this.app.forceUpdate()} }
					margin="normal"
					InputLabelProps={{ shrink: true }}
					/>

				<Spacer />

				<Select
					label="State"
					id="state"
					value={this.app.profileForm.state}
					onChange={ o =>{ this.app.profileForm.state = o.value; this.app.forceUpdate(); } }
					options={STATE_OPTIONS}
					/>

				<Spacer />

				<TextField
					label="Zip"
					id="zip"
					value={this.app.profileForm.zip || ''}
					onChange={ e => {this.app.profileForm.zip = e.currentTarget.value; this.app.forceUpdate();} }
					margin="normal"
					inputProps={{ maxLength:5}}
					style={{width:'100px'}}
					InputLabelProps={{ shrink: true }}
					/>

				<Select
					label="Color Blindness"
					value={this.app.profileForm.colorBlind}
					onChange={ o =>{ this.app.profileForm.colorBlind = o.value; this.app.forceUpdate(); } }
					options={COLOR_BLIND_OPTIONS}
					/>


				
				<div style={{margin:'50px 0', border:'solid 1px #cecece', padding:'15px'}}>
					<b>Opt-in to Researcher Contact</b>
					<div className="p" style={{margin:'15px 0'}}>
						Become more involved by allowing experiment owners to contact you with follow-up emails.<br /><br />
						{ this.app.profileForm.optInToEmailStatus === "Not yet requested" ?
							(!this.app.profileForm.optInButtonClicked ?
								 <Button variant="raised" onClick={this.app.profileForm.optIn}>Opt-in to researcher contact</Button>
								 :
								<div>An email has been sent to you. Please click the confirmation link in the email.</div>
							)
							:
							<div>Status: {this.app.profileForm.optInToEmailStatus}</div>
						}
					</div>
				</div>


			</ShortForm>
		);
	}
}

const Spacer = () => (<span style={{paddingLeft:'20px'}}></span>);


// WEBPACK FOOTER //
// ./src/components/MyProfile.js